import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AbcService {

    massConversionFactors: any = {
        kg: 1,            // base
        lb: 0.453592,     // 1 libra = 0.453592 kg
        g: 0.001,         // 1 gramo = 0.001 kg
        mg: 0.000001,     // 1 mg = 0.000001 kg
        oz: 0.0283495     // 1 onza = 0.0283495 kg
    };

    volumeConversionFactors: any = {
        l: 1,             // Litros como base
        ml: 0.001,        // 1 mililitro = 0.001 litros
        gal: 3.78541,     // 1 galón = 3.78541 litros
        fl_oz: 0.0295735  // 1 onza líquida = 0.0295735 litros
    };

    lengthConversionFactors: any = {
        m: 1,             // Metros como unidad base
        cm: 0.01,         // 1 centímetro = 0.01 metros
        mm: 0.001,        // 1 milímetro = 0.001 metros
        in: 0.0254,       // 1 pulgada = 0.0254 metros
        ft: 0.3048,       // 1 pie = 0.3048 metros
        yd: 0.9144,       // 1 yarda = 0.9144 metros
        km: 1000,         // 1 kilómetro = 1000 metros
        mi: 1609.34       // 1 milla = 1609.34 metros
    };

    constructor() {
    }

    /**
     * @deprecated Redondea el resultado (2 decimales si >= 1, 4 cifras significativas si < 1)
     * y por eso pierde precisión al escribir inventario: 4 lb daban 1.81 kg en vez de 1.814368.
     * Todos los call sites migraron a `convertMeasureRaw()` + `ApiService.to6()` en
     * `fix/precision-unidades`. No usar en código nuevo; se conserva solo por compatibilidad.
     */
    convertMeasure(measure: any, value: any, fromUnit: any, toUnit: any) {
        if (fromUnit !== toUnit) {
            let convertedValue: number = 0;

            if (measure === 'mass') {
                const valueInKg = Number(value) * this.massConversionFactors[fromUnit];
                convertedValue = valueInKg / this.massConversionFactors[toUnit];
            } else if (measure === 'volume') {
                const valueInLiters = Number(value) * this.volumeConversionFactors[fromUnit];
                convertedValue = valueInLiters / this.volumeConversionFactors[toUnit];
            } else if (measure === 'length') {
                const valueInMeters = Number(value) * this.lengthConversionFactors[fromUnit];
                convertedValue = valueInMeters / this.lengthConversionFactors[toUnit];
            } else if (measure === 'pzs') {
                return Number(value);
            }
            // Si el valor convertido es menor a 1, usa 4 cifras significativas; si no, usa 2 decimales.
            return convertedValue < 1 ? Number(parseFloat(convertedValue.toPrecision(4))) : Number(parseFloat(convertedValue.toFixed(2)));
        } else {
            return Number(Number(value).toFixed(2));
        }
    }

    getMeasureType(unit: string): string {
        if (this.massConversionFactors[unit]) {
            return 'mass';
        } else if (this.volumeConversionFactors[unit]) {
            return 'volume';
        } else if (this.lengthConversionFactors[unit]) {
            return 'length';
        }
        return 'pzs'; // Por defecto, si no es masa, volumen o longitud, se asume que es unidad
    }

    getMetricName(unit: string): string {
        const metrics: any = {
            kg: 'Kilogramos', lb: 'Libras', g: 'Gramos', mg: 'Miligramos', oz: 'Onzas',
            l: 'Litros', ml: 'Mililitros', gal: 'Galones',
            m: 'Metros', cm: 'Centímetros', mm: 'Milímetros', in: 'Pulgadas', ft: 'Pies', yd: 'Yardas', km: 'Kilómetros', mi: 'Millas'
        };
        return metrics[unit] || 'Unidades';
    }

    getMetricSymbol(unit: string): string {
        const symbols: any = {
            kg: 'kg', lb: 'lb', g: 'g', mg: 'mg', oz: 'oz',
            l: 'l', ml: 'ml', gal: 'gal',
            m: 'm', cm: 'cm', mm: 'mm', in: 'in', ft: 'ft', yd: 'yd', km: 'km', mi: 'mi',

        };
        return symbols[unit] || 'pzs';
    }

    convertMeasureRaw(measure: any, value: any, fromUnit: any, toUnit: any) {
        if (fromUnit === toUnit) return Number(value);

        if (measure === 'mass') {
            const valueInKg = Number(value) * this.massConversionFactors[fromUnit];
            return valueInKg / this.massConversionFactors[toUnit];
        }

        if (measure === 'volume') {
            const valueInLiters = Number(value) * this.volumeConversionFactors[fromUnit];
            return valueInLiters / this.volumeConversionFactors[toUnit];
        }

        if (measure === 'length') {
            const valueInMeters = Number(value) * this.lengthConversionFactors[fromUnit];
            return valueInMeters / this.lengthConversionFactors[toUnit];
        }

        if (measure === 'pzs') {
            return Number(value);
        }

        return Number(value);
    }

}
